import { withSnackbar } from "notistack";
import Button from "@mui/material/Button";
import { withOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect, useCallback } from "react";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";

import { login } from "../api/auth";
import { LoginCard } from "./styles";
import { LO_STO } from "../util/constants";

const LoginContainer = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try {
        await login(password, username);
        localStorage.setItem(LO_STO.IS_LOGGING, true);
      } catch (err) {
        setIsLoading(false);
        console.error("Login error:", err);
        props.enqueueSnackbar("Invalid username or password", {
          variant: "error"
        });
      }
    },
    [password, username, props]
  );

  const onUsernameChange = useCallback((e) => setUsername(e.target.value), []);

  const onPasswordChange = useCallback((e) => setPassword(e.target.value), []);

  useEffect(() => {
    const error = window.localStorage.getItem(LO_STO.LOGOUT_MESSAGE);

    if (error) {
      props.enqueueSnackbar(error);
      localStorage.removeItem(LO_STO.LOGOUT_MESSAGE);
    }
  }, [props]);

  return (
    <Container component="main" maxWidth="xs">
      <LoginCard>
        <h1>SSP Dashboard</h1>
        <h3>Log in to your account</h3>
        <form noValidate onSubmit={onSubmit}>
          <TextField
            variant="outlined"
            required
            fullWidth
            id="email"
            name="email"
            autoComplete="email"
            autoFocus
            size="small"
            label="Email"
            onChange={onUsernameChange}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            size="small"
            onChange={onPasswordChange}
          />
          <Button type="submit" fullWidth variant="contained" color="primary" size="medium" disableElevation>
            {isLoading ? <CircularProgress color="inherit" size={20} /> : "Log In"}
          </Button>
        </form>
      </LoginCard>
    </Container>
  );
};
export default withOktaAuth(withSnackbar(LoginContainer));
